import { InfoCircleOutlined, MenuOutlined } from '@ant-design/icons';
import TcButton from 'components/UI/button/TcButton';
import HeaderDrawer from 'components/UI/layout/components/HeaderDrawer';
import HeaderUser from 'components/UI/layout/components/HeaderUser';
import TermsAndCondition from 'components/UI/layout/components/termsAndConditions/TermsAndCondition';
import UnregisteredOrdersToJet from 'components/UI/layout/components/UnregisteredOrdersToJet';
import routes from 'global/Constants/routes';
import { FC, useCallback, useState } from 'react';
import { RxDashboard } from 'react-icons/rx';
import { useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import { RootState } from 'redux/store';

const isProductionServer = process.env.REACT_APP_NOD_ENV === 'production';

const DashboardHeader: FC = () => {
  //states
  const [showDrawer, setShowDrawer] = useState<boolean>(false);
  const userProfile = useSelector((state: RootState) => state.user.userProfile);
  const customerUser = useSelector((state: RootState) => state.user.customerUser);

  //hooks
  const { pathname } = useLocation();

  //functions
  const toggleDrawer = useCallback(() => setShowDrawer((prevState) => !prevState), []);

  return (
    <header className='sticky top-0 left-0 z-50 flex items-center justify-between w-full gap-2 px-6 py-5 border-b h-fit bg-t-bg-color print:hidden'>
      <div className='flex items-center gap-2'>
        <Link to={routes.home.path}>
          <img src='/etipaxLogo.svg' className='object-contain max-w-[100px] mx-auto' alt='ای تیپاکسس' />
        </Link>
        {pathname.startsWith('/dashboard') && !!customerUser && <h1 className='hidden text-lg font-bold select-none md:block'>پنل {customerUser?.customerTitle}</h1>}
      </div>

      {!isProductionServer && (
        <div className='px-3 py-1 mr-5 bg-t-error-color rounded-xl text-t-bg-color animate-pulse'>
          <InfoCircleOutlined className='mt-1 ml-1 text-lg inherit-color ' />
          <span className='text-lg font-semibold text-t-bg-color '> محیط تست</span>
        </div>
      )}

      {pathname.startsWith('/dashboard') && <MenuOutlined className='md:hidden' onClick={toggleDrawer} />}
      <div className='flex items-center mr-auto gap-x-2'>
        {userProfile && pathname.startsWith('/dashboard') && customerUser?.customerCode && <span className='text-xs'>کد مشتری : {customerUser.customerCode}</span>}
        {/* سفارشات در انتظار ارسال مجدد به جت  */}
        <UnregisteredOrdersToJet />

        {!!userProfile && !pathname.startsWith('/dashboard') && (
          <Link to={routes.dashboardHome.path} className=''>
            <TcButton className='flex items-center min-w-[unset] gap-2'>
              <RxDashboard />
              <span className='inline text-xs xs:text-base'>داشبورد</span>
            </TcButton>
          </Link>
        )}

        <HeaderUser />

        {/* {userProfile && isAllowed && (
          <Link to={routes.orderSubmit.path}>
            <TcButton type='primary'>ثبت سفارش</TcButton>
          </Link>
        )} */}
      </div>
      <HeaderDrawer open={showDrawer} close={toggleDrawer} />
      <TermsAndCondition />
    </header>
  );
};

export default DashboardHeader;
